import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
import _Tooltip from "@mui/material/Tooltip";
import _ButtonBase from "@mui/material/ButtonBase";
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Button } from '../button';
import { ExternalMediaList } from '../external-media-list';
export function RideStepPopup({
  theme,
  step,
  openPhotoDialog,
  onRemove,
  onEdit,
  onClose
}) {
  const {
    t
  } = useTranslation();
  const {
    title,
    description,
    photos
  } = step;
  const photo = photos.sort((a, b) => a.id && b.id ? a.id - b.id : 0)[0];
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Wrapper, null, photo && /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "top",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, photo.title || title, " ", photo.copyright && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA9 ", photo.copyright))
  }, /*#__PURE__*/React.createElement(_ButtonBase, {
    onClick: () => openPhotoDialog(step)
  }, /*#__PURE__*/React.createElement(StyledPhotoWrapper, {
    url: photo.thumbnailUrl || ''
  }))), /*#__PURE__*/React.createElement(CloseButtonWrapper, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: () => onClose(),
    size: "small"
  }, /*#__PURE__*/React.createElement(_Close, null)))), /*#__PURE__*/React.createElement(StyledHeader, {
    className: photo ? '' : 'shifted'
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(StyledTitle, {
    title: title || '',
    variant: "h6"
  }, title))), description && /*#__PURE__*/React.createElement(StyledContent, null, /*#__PURE__*/React.createElement(_Typography, {
    component: "p",
    variant: "caption"
  }, description)), 'medias' in step && step.medias.length > 0 && /*#__PURE__*/React.createElement(ExternalMediaList, {
    medias: step.medias
  }), (onRemove || onEdit) && step && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1,
    justifyContent: "flex-end",
    padding: "0 16px 8px"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "error",
    disabled: !step,
    onClick: () => {
      onRemove?.();
      onClose();
    },
    size: "small",
    variant: "outlined"
  }, t('commons.actions.remove')), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: !step,
    onClick: () => {
      onEdit?.();
      onClose();
    },
    size: "small",
    variant: "contained"
  }, t('commons.actions.update')))));
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: max(calc(50vh - 24px), 400px);
  overflow-y: hidden;
  position: relative;
  width: min(100vw - 120px, 350px);
`;
const CloseButtonWrapper = styled.div`
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const StyledPhotoWrapper = styled.div`
  background-color: whitesmoke;
  background-image: ${({
  url
}) => `url(${url})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 50%;
  width: 100%;
`;
const StyledHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  padding: 16px 16px 8px 16px;

  &.shifted {
    padding: 16px 54px 8px 16px;
  }
`;
const StyledTitle = styled(_Typography)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const StyledContent = styled.div`
  flex-shrink: 1;
  overflow-y: auto;
  padding: 0 16px 16px;
`;